import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPassesUrlByAuthorId } from "@/components/edition/category/components/content/useProductItemHandlers";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { Typography } from "@mui/material";
import Link from "next/link";
import { TabMessageBox } from "./PurchaseLayouts";
const PurchaseNoFreepassTab = (param)=>{
    let { product  } = param;
    const passesLandingUrl = getPassesUrlByAuthorId(product.author_id);
    const handleClick = ()=>{
        mixpanelEvent("CTA Button Clicked", {
            "Button Type": "case5)무료체험이 아닌 일반구매 유도할 유저",
            "Button Name": "무제한 이용하기",
            "Button URL": passesLandingUrl,
            Position: "상품상세페이지 구매모듈"
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TabMessageBox, {
                sx: {
                    mb: 2.5
                },
                children: /*#__PURE__*/ _jsxs(Typography, {
                    variant: "subtitle1",
                    sx: {
                        color: "text.title"
                    },
                    children: [
                        "해당 상품은 '전용 패스'를 구매 후",
                        /*#__PURE__*/ _jsx("br", {}),
                        "이용할 수 있어요."
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: passesLandingUrl,
                children: /*#__PURE__*/ _jsx(Button, {
                    size: "large",
                    variant: "contained",
                    fullWidth: true,
                    onClick: handleClick,
                    children: "무제한 이용하기"
                })
            })
        ]
    });
};
export default PurchaseNoFreepassTab;
